import styled from "styled-components";
import DefaultContainer from "./DefaultContainer";

const Container = styled.div`
  display: flex;
  justify-content: center;
  background-color: #f8f9fa;
  padding: 80px 0;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  width: 100%;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: center;
`;

const Title = styled.div`
  font-size: 42px;
  font-weight: 600;
  color: #343a40;
`;

const SubTitle = styled.div`
  font-size: 18px;
  color: #6c757d;
  line-height: 1.6;
`;

const Description = styled.div`
  font-size: 18px;
  line-height: 1.8;
  color: #6c757d;
  text-align: center;
  max-width: 800px;
`;

const FeaturesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`;

const FeaturesTitle = styled.div`
  font-size: 32px;
  font-weight: 600;
  color: #343a40;
  text-align: center;
`;

const FeaturesList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
`;

const FeatureItem = styled.div`
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const FeatureIcon = styled.div`
  font-size: 36px;
  color: #007bff;
`;

const FeatureText = styled.div`
  font-size: 16px;
  color: #6c757d;
  line-height: 1.6;
`;

const CTAButton = styled.a`
  background: #007bff;
  color: white;
  padding: 16px 40px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    background: #0056b3;
  }
`;

const LoNeSection = () => {
  return (
    <Container>
      <DefaultContainer>
        <Contents>
          <Header>
            <Title>LoNe</Title>
            <SubTitle><strong>LoNe</strong>: Local Network - 장소 기반 소셜 네트워크</SubTitle>
          </Header>

          <Description>
            LoNe는 장소를 중심으로 사람들을 연결하는 새로운 소셜 네트워크 서비스입니다.
            <br />
            <br />
            당신이 방문한 장소에 대한 경험을 공유하고, 다른 사람들의 리뷰를 통해
            주변의 숨은 명소를 발견하세요.
          </Description>

          <FeaturesSection>
            <FeaturesTitle>주요 기능</FeaturesTitle>
            <FeaturesList>
              <FeatureItem>
                <FeatureIcon>👥</FeatureIcon>
                <FeatureText>소셜 네트워크 서비스로 친구들과 장소 경험을 공유</FeatureText>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon>📝</FeatureIcon>
                <FeatureText>장소를 연결하여 피드로 장소에 대한 리뷰 작성</FeatureText>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon>📍</FeatureIcon>
                <FeatureText>GPS 기반으로 주변 장소의 리뷰를 실시간으로 확인</FeatureText>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon>🌐</FeatureIcon>
                <FeatureText>웹 기반 서비스로 어디서나 쉽게 접속 가능</FeatureText>
              </FeatureItem>
            </FeaturesList>
          </FeaturesSection>

          <CTAButton
            href="https://lone.followingmoments.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            LoNe 방문하기 →
          </CTAButton>
        </Contents>
      </DefaultContainer>
    </Container>
  );
};

export default LoNeSection;
